import { Capacitor } from "@capacitor/core";

const listeners = new Set();
const key = process.env.REACT_APP_GOOGLE_MAPS_KEY || "";

export const MAP_DIAGNOSTICS_ENABLED = process.env.REACT_APP_MAP_DIAGNOSTICS === "1"
  && Capacitor.getPlatform() === "ios";

const initialState = {
  href: window.location.href,
  origin: window.location.origin,
  referrer: document.referrer || "(empty)",
  userAgent: navigator.userAgent,
  keyPresent: Boolean(key),
  keyLength: key.length,
  keyPrefix: key ? key.slice(0, 4) : "",
  keySuffix: key ? key.slice(-4) : "",
  mapScript: "WAITING",
  googleObject: Boolean(window.google),
  googleMaps: Boolean(window.google?.maps),
  googleMapsMap: typeof window.google?.maps?.Map === "function",
  authFailure: false,
  mapCreated: false,
  containerWidth: null,
  containerHeight: null,
  latitude: null,
  longitude: null,
  locationValid: null,
  failureType: null,
  lastError: null,
  lastEvent: null,
};

let state = initialState;

const errorDetails = (error) => error ? {
  name: error.name || error.constructor?.name || "Error",
  message: error.message || String(error),
  stack: error.stack || null,
  type: typeof error,
} : null;

export function recordMapDiagnostic(event, details = {}) {
  const timestamp = new Date().toISOString();
  const next = { ...details };
  if (details.error) {
    next.lastError = errorDetails(details.error);
    delete next.error;
  }
  state = {
    ...state,
    ...next,
    googleObject: Boolean(window.google),
    googleMaps: Boolean(window.google?.maps),
    googleMapsMap: typeof window.google?.maps?.Map === "function",
    lastEvent: { event, timestamp },
  };
  const output = { event, timestamp, ...state };
  // The key itself is deliberately never part of state or output.
  console.info("[ZunoMapDiagnostic]", output);
  listeners.forEach((listener) => listener(state));
  return state;
}

export function getMapDiagnosticState() { return state; }

export function subscribeMapDiagnostics(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function installMapAuthDiagnostic() {
  window.gm_authFailure = () => {
    const error = new Error("Google Maps authorization failure");
    const detail = { code: "maps/auth", message: error.message };
    recordMapDiagnostic("MAP_AUTH_FAILURE", {
      authFailure: true,
      failureType: "AUTH_FAILURE",
      lastError: errorDetails(error),
    });
    window.dispatchEvent(new CustomEvent("zuno:map-error", { detail }));
  };
}

export function classifyMapFailure(current = state) {
  if (current.authFailure) return "AUTH_FAILURE";
  if (current.containerWidth === 0 || current.containerHeight === 0) return "CONTAINER_FAILURE";
  if (current.locationValid === false) return "LOCATION_FAILURE";
  if (current.mapScript !== "LOADED") return "SCRIPT_NOT_LOADED";
  if (current.lastEvent?.event === "MAP_CONSTRUCTOR_ERROR") return "MAP_CONSTRUCTOR_FAILURE";
  return "UNKNOWN_FAILURE";
}
